import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/website/website/node_modules/next/dist/client/link.js");
